/**
 * wld-accordion-lightbox
 * ----------------------
 * Lätt, fristående lightbox för accordion-bilder (produktinformation/storleksguide/
 * hanteringsråd). Klick på en bild öppnar den i full storlek i en <dialog>.
 * Stäng med X, Esc eller klick utanför bilden. Inga beroenden, rör inget annat.
 *
 * Aktiveras genom att wrappa bilder i <wld-accordion-lightbox> (se snippet
 * wld-accordion-images.liquid). Bilderna måste ha data-full-src (högupplöst URL).
 */
(function () {
  if (customElements.get('wld-accordion-lightbox')) return;

  /** En delad dialog för hela sidan (skapas vid första öppning). */
  let sharedDialog = null;

  function ensureDialog() {
    if (sharedDialog) return sharedDialog;
    const dialog = document.createElement('dialog');
    dialog.className = 'wld-lightbox';
    dialog.innerHTML =
      '<button type="button" class="wld-lightbox__close" aria-label="Stäng">&times;</button>' +
      '<img class="wld-lightbox__img" alt="" />';

    const close = () => {
      if (dialog.open) dialog.close();
    };

    // Klick utanför bilden (på backdrop) stänger.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.querySelector('.wld-lightbox__close').addEventListener('click', close);
    dialog.addEventListener('close', () => {
      const img = dialog.querySelector('.wld-lightbox__img');
      img.removeAttribute('src');
    });

    document.body.appendChild(dialog);
    sharedDialog = dialog;
    return dialog;
  }

  function openLightbox(src, alt) {
    const dialog = ensureDialog();
    const img = dialog.querySelector('.wld-lightbox__img');
    img.src = src;
    img.alt = alt || '';
    if (!dialog.open) dialog.showModal();
  }

  class WldAccordionLightbox extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
    }

    #onClick = (event) => {
      const img = event.target.closest('img');
      if (!img || !this.contains(img)) return;
      const full = img.getAttribute('data-full-src') || img.currentSrc || img.src;
      if (!full) return;
      openLightbox(full, img.alt);
    };
  }

  customElements.define('wld-accordion-lightbox', WldAccordionLightbox);
})();
